"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareOnlyHeaderLayoutProps = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _DefaultLayoutFeature = require("../default/DefaultLayoutFeature");
const prepareOnlyHeaderLayoutProps = ({
  page: {
    appLoaders,
    cultureSettings,
    language,
    features,
    developmentInfo,
    environment,
    servicesUrls,
    token,
    tenant,
    pageMetaData,
    requiredServicesUrls,
    optionalServiceUrls,
    periodCode,
    useLegacyKendoCulture = false,
    useLegacyTokenService = false,
    enableWebVitalsCollection = false,
    enableFavorites = false,
    operationId
  },
  layout: {
    languages,
    showTopAreaSearchOnScroll = false,
    translations,
    defaultTranslations,
    componentsProps
  }
}) => ({
  page: {
    ...(appLoaders && {
      appLoaders
    }),
    ...(pageMetaData && {
      pageMetaData
    }),
    ...(translations && {
      translations
    }),
    ...(defaultTranslations && {
      defaultTranslations
    }),
    cultureSettings,
    language,
    customerId: _auth.NOT_LOGGED_IN_USER_ID,
    developmentInfo,
    environment,
    features: [...features.values()],
    isProduction: process.env.NODE_ENV === 'production',
    pageBuiltAt: new Date().toString(),
    pageFeatures: _DefaultLayoutFeature.DefaultLayoutFeature,
    periodCode,
    servicesUrls: (0, _configurationManager.pickBaseUrlsOfServices)(servicesUrls, requiredServicesUrls, optionalServiceUrls),
    tenant,
    token,
    useLegacyKendoCulture,
    useLegacyTokenService,
    enableWebVitalsCollection,
    enableFavorites,
    operationId
  },
  layout: {
    ...(languages && {
      languages
    }),
    showTopAreaSearchOnScroll,
    ...(componentsProps && {
      componentsProps
    })
  }
});
exports.prepareOnlyHeaderLayoutProps = prepareOnlyHeaderLayoutProps;
